import { ContentManagerRequest } from 'api/ContentManagerRequest';

export interface QrConfigPayload {
    name: string;
    description?: string;
    target_url: string;
    is_active?: boolean;
}

export const getQrConfigurations = (page = 1, search = '', pageSize = 20) =>
    ContentManagerRequest.get('/api/qr-configurations/', {
        params: { page, search, page_size: pageSize },
    });

export const createQrConfiguration = (payload: QrConfigPayload) =>
    ContentManagerRequest.post('/api/qr-configurations/', payload);

export const updateQrConfiguration = (id: number, payload: Partial<QrConfigPayload>) =>
    ContentManagerRequest.put(`/api/qr-configurations/${id}/`, payload);

export const deleteQrConfiguration = (id: number) =>
    ContentManagerRequest.delete(`/api/qr-configurations/${id}/`);

export const getQrImageUrl = (slug: string, size: number, format: 'png' | 'svg') =>
    `${process.env.REACT_APP_CM}/api/qr/${slug}/image?size=${size}&img_format=${format}`;

export const getQrStats = (dateFrom?: string, dateTo?: string) =>
    ContentManagerRequest.get('/api/qr/stats/', {
        params: { date_from: dateFrom, date_to: dateTo },
    });
